import React from "react";
import { Button, Text, Heading, VStack, Flex, Box } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";

const heading = "How can I serve you?";
const paragraph = `Analytical and detail-oriented Software Engineer with expertise in TypeScript, React, Node, and AWS Cloud. 

Proven track record in optimising cloud infrastructure, delivering quality micro frontends and full stack engineering for large corporates in publishing, gaming, finance and consulting. 
`;
const cta = "Download Resumé PDF";

const Hero = () => (
  <div id="hero-section">
    <FullScreenSection
      alignContent="flex-start"
      justifyContent="center"
      alignItems="flex-start"
      width="100%"
      flexDirection="column"
      isDarkBackground={false}
      minHeight="95vh"
    >
      <VStack
        alignContent="flex-start"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={6}
        ml={8}
      >
        <Flex direction="column" alignItems="flex-start" maxWidth="900px">
          <Heading
            color="#FAFAFA"
            fontFamily="'Source Serif Pro', serif"
            fontSize="32px"
            lineHeight="1.4"
            fontWeight="400"
          >
            {heading}
          </Heading>

          <Text
            color="#F5F5F5"
            fontFamily="'Roboto Flex', sans-serif"
            fontSize="24px"
            lineHeight="36px"
            mt="38px"
            maxW="100%"
          >
            {paragraph}
          </Text>

          <Box
            mt={{ base: "40px", md: "73px" }}
            mb={{ base: "10px", md: "-36px" }}
            fontFamily="'Source Serif 4 18pt', serif"
            fontSize="14px"
            fontWeight="700"
            color="#1A202C"
          >
            <a href="/downloads/Xola_dos_Santos_Brief_Re_sume_.pdf">
              <Button
                borderRadius="3px"
                backgroundColor="#FFF"
                color="navyBlue.500"
                px="16px"
                py="8px"
                target="_blank"
                rel="noopener noreferrer"
                fontWeight="700"
                _hover={{
                  backgroundColor: "rgba(250, 250, 250, 0.9)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
                transition="all 0.3s ease"
              >
                {cta}
              </Button>
            </a>
          </Box>
        </Flex>
      </VStack>
    </FullScreenSection>
  </div>
);

export default Hero;
